<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <el-select v-model="team" style="width: 200px;margin-top: 10px" @change="initData">
      <el-option v-for="item in teamList" :label="item.label" :value="item.value" :key="item.value"></el-option>
    </el-select>
    <div class="out_font_class">实时数据</div>
    <div style="display: flex;">
      <div class="outer_layer_class">
        <div class="font_class">线索(个)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ clue }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">机会(个)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ chance }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">未成单客户(个)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ notWinCustomer }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">成单客户(个)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ winCustomer }}</div>
      </div>
    </div>
<!------------------------------业绩数据--------------------->
    <div style="display: flex;margin-top: 20px;width: 1600px">
      <div class="out_font_class" style="width: 120px;margin-top: 0">业绩数据</div>
      <div style="width: 120px;font-size: 20px;margin-top: 0">{{ showNumbers }}</div>
      <div style="width: 230px">
        <el-date-picker
            unlink-panels
            style="width:230px;"
            v-model="businessDate"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getBusinessData"
        />
      </div>
      <el-button style="margin-left: 10px" type="primary" @click="handleWeek('prev')">上一周</el-button>
      <el-button type="primary" @click="handleWeek('current')">本周</el-button>
      <el-button type="primary" @click="handleWeek('next')">下一周</el-button>
      <el-button type="primary" @click="handleMonth('prev')">上一月</el-button>
      <el-button type="primary" @click="handleMonth('current')">本月</el-button>
      <el-button type="primary" @click="handleMonth('next')">下一月</el-button>
      <el-button type="primary" @click="handleQuarter('prev')">上一季度</el-button>
      <el-button type="primary" @click="handleQuarter('current')">本季度</el-button>
      <el-button type="primary" @click="handleQuarter('next')">下一季度</el-button>
      <el-button type="primary" @click="handleYear('prev')">上一年度</el-button>
      <el-button type="primary" @click="handleYear('current')">本年度</el-button>
      <el-button type="primary" @click="handleYear('next')">下一年度</el-button>
    </div>

    <div style="margin-top: 10px;display: flex;flex-wrap: wrap;height: auto">
      <div class="outer_layer_class" >
        <div class="font_class">销售额(￥)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ salesAmount }}</div>
      </div>
      <div class="outer_layer_class" >
        <div class="font_class">销售量(套)</div>
        <div style="font-size: 40px;color: #4d90ff">{{ salesCnt }}</div>
      </div>
      <div class="outer_layer_class" >
        <div class="font_class">成单</div>
        <div style="font-size: 40px;color: #4d90ff">{{ winCnt }}</div>
      </div>
      <div class="outer_layer_class" >
        <div class="font_class">维护续期</div>
        <div style="font-size: 40px;color: #4d90ff">{{ maintainCnt }}</div>
      </div>
      <div class="outer_layer_class" >
        <div class="font_class">报价</div>
        <div style="font-size: 40px;color: #4d90ff">{{ quoteCnt }}</div>
      </div>
      <div class="outer_layer_class" >
        <div class="font_class">失单</div>
        <div style="font-size: 40px;color: #4d90ff">{{ failCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">有效拜访</div>
        <div style="font-size: 40px;color: #4d90ff">{{ visitCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">有效电话</div>
        <div style="font-size: 40px;color: #4d90ff">{{ phoneCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">线索转机会</div>
        <div style="font-size: 40px;color: #4d90ff">{{ clueToChanceCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">新增机会</div>
        <div style="font-size: 40px;color: #4d90ff">{{ newChanceCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">新增客户</div>
        <div style="font-size: 40px;color: #4d90ff">{{ newCustomerCnt }}</div>
      </div>
      <div class="outer_layer_class">
        <div class="font_class">新增联系人</div>
        <div style="font-size: 40px;color: #4d90ff">{{ newContactCnt }}</div>
      </div>
    </div>
    <!----------------历史业绩同比(套)-------------------->
    <div style="display: flex;margin-top: 10px">
      <div class="out_font_class" style="width: 250px;margin-top: 0">历史业绩同比(套)</div>
      <el-select style="margin-left: 20px;width:250px" v-model="kpiName" @change="getHistoryBusinessData">
        <el-option v-for="item in kpiNameList" :label="item.kpi_name" :value="item.kpi_name" :key="item.kpi_name"></el-option>
      </el-select>
      <el-select style="margin-left: 20px;width:250px" v-model="year" multiple @change="getHistoryBusinessData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <!----------------折线图-------------->
    <div style="width: 100%;height: 300px;margin-top: 10px" id="historicalChart"/>

    <!-----------------机会漏斗--------------------------->
    <div style="display: flex;width: 1600px">
      <div class="out_font_class" style="width: 200px;margin-top: 0">机会漏斗</div>
      <div style="width: 230px">
        <el-date-picker
            unlink-panels
            style="width:230px;"
            v-model="chanceFunnelDate"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getChanceFunnelData"
        />
      </div>

      <div class="out_font_class" style="width: 200px;margin-top: 0">机会变动</div>
      <div style="width: 230px">
        <el-date-picker
            unlink-panels
            style="width:230px;"
            v-model="chanceChangeDate"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getChanceChangeData"
        />
      </div>

    </div>

    <div style="display: flex;margin-top: 10px;width: 1600px">
      <div style="width:430px;background-color:#f8f8f8;margin-left: 20px ">
        <div style="position: relative;width: 430px;height: 50px;">
          <div class="d_shadow"></div>
          <div class="d_class">{{ chanceD }}</div>
          <span style="position:absolute;top:12px;left: 10px;font-size: 20px;color: #0069d3">D</span>
        </div>
        <div style="position: relative;width: 430px;height: 50px;">
          <div class="c_shadow"></div>
          <div class="c_class">{{ chanceC }}</div>
          <span style="position:absolute;top:10px;left: 55px;font-size: 20px;color: #39CDE5FF">C</span>
        </div>
        <div style="position: relative;width: 430px;height: 50px;">
          <div class="b_shadow"></div>
          <div class="b_class">{{ chanceB }}</div>
          <span style="position:absolute;top:10px;left: 90px;font-size: 20px;color: #4FE5BBFF">B</span>
        </div>
        <div style="position: relative;width: 430px;height: 50px;">
          <div class="a_shadow"></div>
          <div class="a_class" style="text-align: center;font-size:25px;color: white;line-height: 50px">{{ chanceA }}</div>
          <span style="position:absolute;top:10px;left: 120px;font-size: 20px;color: #1ECC7CFF">A</span>
        </div>
        <div style="position: relative;width: 430px;height: 50px;">
          <div style="width: 28%;height: 100%;margin-left: 36%;;display: flex">
            <div class="w_class">{{ chanceW }}</div>
            <div class="f_class">{{ chanceF }}</div>
          </div>
          <span style="position: absolute;top: 10px;left: 130px;font-size: 20px;color: #E17C00FF;">W</span>
          <span style="position: absolute;top: 10px;left: 280px;font-size: 20px;color: #777777FF;">F</span>
        </div>
      </div>
<!---------------------------------流程图-------------使用绝对定位设置-------------------------->
      <div style="width: 1000px;position: relative;background-color: #f8f8f8;margin-left: 20px">
        <div class="w_image_class">W</div>
        <div class="d_image_class">D</div>
        <div class="c_image_class">C</div>
        <div class="b_image_class">B</div>
        <div class="a_image_class">A</div>
        <div class="f_image_class">F</div>
<!---------------向右箭头定位--------------------->
        <div class="arrow-line-right" style="width: 50px;position: absolute;left: 30px;top:125px"></div>
        <div class="arrow-line-right" style="position: absolute;left: 240px;top: 115px;"></div>
        <div class="arrow-line-right" style="position: absolute;left: 490px;top: 115px;"></div>
        <div class="arrow-line-right" style="position: absolute;left: 740px;top: 115px;"></div>
<!--------------------向左箭头定位----------------->
        <div class="arrow-line-left" style="position: absolute;left: 245px;top: 135px"></div>
        <div class="arrow-line-left" style="position: absolute;left: 495px;top: 135px"></div>
        <div class="arrow-line-left" style="position: absolute;left: 745px;top: 135px"></div>
        <!-------------------向上箭头定位----------------->
        <div class="arrow-up" style="position: absolute;left: 915px;top:70px"></div>
<!-------------------向下箭头定位----------------->
        <div class="arrow-down" style="position: absolute;left: 165px;top: 155px"></div>
        <div class="arrow-down" style="position: absolute;left: 415px;top: 155px"></div>
        <div class="arrow-down" style="position: absolute;left: 665px;top: 155px"></div>
        <div class="arrow-down" style="position: absolute;left: 915px;top: 155px"></div>
<!-------------------数字定位---------------------->
        <span style="position: absolute;left: 40px;top:95px;font-size: 20px;color: #0069d3">{{ changeClueToChanceCnt }}</span>
        <span style="position: absolute;left: 285px;top:85px;font-size: 20px;color: #0069d3">{{ changeChanceDToCCnt }}</span>
        <span style="position: absolute;left: 540px;top:85px;font-size: 20px;color: #0069d3">{{ changeChanceCToBCnt }}</span>
        <span style="position: absolute;left: 785px;top:85px;font-size: 20px;color: #0069d3">{{ changeChanceBToACnt }}</span>
        <span style="position: absolute;left: 930px;top:70px;font-size: 20px;color: #0069d3">{{ changeChanceAToWCnt }}</span>
        <span style="position: absolute;left: 930px;top:155px;font-size: 20px;color: #777777FF">{{ changeChanceAToFCnt }}</span>
        <span style="position: absolute;left: 785px;top:135px;font-size: 20px;color: #777777FF">{{ changeChanceAToBCnt }}</span>
        <span style="position: absolute;left: 680px;top:155px;font-size: 20px;color: #777777FF">{{ changeChanceBToFCnt }}</span>
        <span style="position: absolute;left: 540px;top:135px;font-size: 20px;color: #777777FF">{{ changeChanceBToCCnt }}</span>
        <span style="position: absolute;left: 430px;top:155px;font-size: 20px;color: #777777FF">{{ changeChanceCToFCnt }}</span>
        <span style="position: absolute;left: 285px;top:135px;font-size: 20px;color: #777777FF">{{ changeChanceCToDCnt }}</span>
        <span style="position: absolute;left: 180px;top:155px;font-size: 20px;color: #777777FF">{{ changeChanceDToFCnt }}</span>
      </div>
    </div>

<!-----------有效电话量-------------->
    <div v-for="item in kpiList">
      <div style="display: flex;margin-top: 10px">
        <div class="out_font_class" style="width: 250px;margin-top: 0">{{item.name}}</div>
        <div style="width: 230px">
          <el-date-picker
              style="width:230px;"
              unlink-panels
              v-model="item.date"
              type="daterange"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getKpiData(item)"
          />
        </div>
        <el-select v-model="item.dimension" style="width:100px;margin-left: 10px" @change="getKpiData(item)">
          <el-option label="日" value="day" key="day"></el-option>
          <el-option label="周" value="week" key="week"></el-option>
          <el-option label="月" value="month" key="month"></el-option>
          <el-option label="季度" value="quarter" key="quarter"></el-option>
          <el-option label="年" value="year" key="year"></el-option>
        </el-select>
      </div>
      <div style="width: 100%;height: 300px" :id="item.elementId" />
    </div>

  </div>

</template>

<script>

import * as echarts from "echarts";
import dayjs from "dayjs";



export default {
  name: "BusinessData",

  data() {
    return {
      businessDate: [],
      businessStartDate: Date(),
      businessEndDate: Date(),
      chanceChangeDate: '',
      chanceFunnelDate: '',
      team:'',
      kpiName:'',
      historyLengthData:[],
      historySeriesData:[],
      kpiNameList:[],
      kpiList:[],
      year:[],
      yearList:[],
      clue:0,
      chance:0,
      notWinCustomer:0,
      winCustomer:0,
      currentDate: new Date(),
      chanceD:0,
      chanceC:0,
      chanceB:0,
      chanceA:0,
      chanceW:0,
      chanceF:0,
      changeClueToChanceCnt:0,
      changeChanceDToCCnt:0,
      changeChanceCToBCnt:0,
      changeChanceBToACnt:0,
      changeChanceAToWCnt:0,
      changeChanceAToFCnt:0,
      changeChanceAToBCnt:0,
      changeChanceBToFCnt:0,
      changeChanceBToCCnt:0,
      changeChanceCToFCnt:0,
      changeChanceCToDCnt:0,
      changeChanceDToFCnt:0,
      salesAmount:0,
      salesCnt: 0,
      winCnt:0,
      maintainCnt:0,
      quoteCnt:0,
      failCnt:0,
      visitCnt:0,
      phoneCnt:0,
      clueToChanceCnt:0,
      newChanceCnt:0,
      newCustomerCnt:0,
      newContactCnt:0,
      teamList:[],
      kpiData:{},
      showNumbers:'',

    }
  },

  async created() {
    await this.getCurrentWeekRange(); //优先级高
    await this.getYearList();
    await this.getAllTeam();
    await this.initData();

  },

  methods: {
    async initData(){
      await this.getRealTimeData();
      await this.getBusinessData();
      await this.getKpiNameByTeam();
      await this.getChanceFunnelData();
      await this.getChanceChangeData();

      for (let item of this.kpiList){
        await this.getKpiData(item);
      }

    },

    //获取实时数据
    async getRealTimeData(){
      let params = {team:this.team}
      let data = await this.$http('crmTeamService.getRealTimeData',params);
      if(!data){
        return;
      }
      this.clue = data.clue;
      this.chance = data.chance;
      this.notWinCustomer = data.notWinCustomer;
      this.winCustomer = data.winCustomer;
    },
    //获取业务数据
    async getBusinessData(){
      let params = {team:this.team}
      if(this.businessDate){
        params.startDate = this.businessDate[0];
        params.endDate = this.businessDate[1];
      }
      let data = await this.$http('crmTeamService.getBusinessData',params);
      if(!data){
        return;
      }
      this.salesAmount = data.salesTotalAmount.toLocaleString();
      this.salesCnt = data.salesTotalCnt.toLocaleString();
      this.winCnt = data.winTotalCnt.toLocaleString();
      this.maintainCnt = data.maintainTotalCnt.toLocaleString();
      this.quoteCnt = data.quoteTotalCnt.toLocaleString();
      this.failCnt = data.failTotalCnt.toLocaleString();
      this.visitCnt = data.visitTotalCnt.toLocaleString();
      this.phoneCnt = data.phoneTotalCnt.toLocaleString();
      this.clueToChanceCnt = data.clueToChanceTotalCnt.toLocaleString();
      this.newChanceCnt = data.newChanceTotalCnt.toLocaleString();
      this.newCustomerCnt = data.newCustomerTotalCnt.toLocaleString();
      this.newContactCnt = data.newContactTotalCnt.toLocaleString();
    },

    //获取团队数据
    async getAllTeam(){
      this.teamList = await this.$http('crmTeamService.getTeamByRole');
      if(this.teamList){
        this.team = this.teamList[0].value;
        await this.getKpiNameByTeam();
      }
    },

    //根据团队获取团队的kpiName
    async getKpiNameByTeam(){
      if(!this.team){
        return;
      }
      let params = {team:this.team}
      this.kpiNameList = await this.$http('crmTeamService.getKpiNameByTeam',params);
      if(this.kpiNameList.length > 0){
        this.kpiName = this.kpiNameList[0].kpi_name;
        await this.getHistoryBusinessData();
      }
    },
    //获取年数据
    async getYearList(){
      const now = dayjs();
      this.year = [];
      this.year.push(now.year()+'');
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    //获取机会漏斗数据
    async getChanceFunnelData(){
      if(!this.team){
        return;
      }
      let params = {team:this.team}
      if(this.chanceFunnelDate){
        params.startDate = this.chanceFunnelDate[0];
        params.endDate = this.chanceFunnelDate[1];
      }
      let data = await this.$http('crmTeamService.getChanceFunnelData',params);
      if(!data){
        return;
      }
      this.chanceD = data.chanceD;
      this.chanceC = data.chanceC;
      this.chanceB = data.chanceB;
      this.chanceA = data.chanceA;
      this.chanceW = data.chanceW;
      this.chanceF = data.chanceF;
    },
    //获取机会变动数据
    async getChanceChangeData(){
      if(!this.team){
        return;
      }
      let params = {team:this.team}
      if(this.chanceChangeDate){
        params.startDate = this.chanceChangeDate[0];
        params.endDate = this.chanceChangeDate[1];
      }
      let data = await this.$http('crmTeamService.getChanceChangeData',params);
      if(!data){
        return;
      }
      this.changeClueToChanceCnt = data.changeClueToChanceCnt;
      this.changeChanceDToCCnt = data.changeChanceDToCCnt;
      this.changeChanceCToBCnt = data.changeChanceCToBCnt;
      this.changeChanceBToACnt = data.changeChanceBToACnt;
      this.changeChanceAToWCnt = data.changeChanceAToWCnt;
      this.changeChanceAToFCnt = data.changeChanceAToFCnt;
      this.changeChanceAToBCnt = data.changeChanceAToBCnt;
      this.changeChanceBToFCnt = data.changeChanceBToFCnt;
      this.changeChanceBToCCnt = data.changeChanceBToCCnt;
      this.changeChanceCToFCnt = data.changeChanceCToFCnt;
      this.changeChanceCToDCnt = data.changeChanceCToDCnt;
      this.changeChanceDToFCnt = data.changeChanceDToFCnt;
    },

    //获取历史业绩同比数据
    async getHistoryBusinessData(){
      if(!this.kpiName || !this.year){
        return;
      }
      let params = {team:this.team,kpiName:this.kpiName,year:this.year}
      let data = await this.$http('crmTeamService.getHistoryBusinessData',params);
      if(!data){
        return;
      }
      this.historyLengthData = data.lengthData;
      this.historySeriesData = data.seriesData;
      await this.renderHistoryEcharts();
    },


    //历史业绩图加载
    async renderHistoryEcharts() {
      const chartDom = document.getElementById('historicalChart');
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(chartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(chartDom);
      myChart.setOption(this.getHistoryChartOptions(), true);
    },

    //获取基本的KPI数据
    async getKpiData(item) {
      if (item.date !== undefined && item.date.length === 2) {
        let params = {
          startDate: item.date[0],
          endDate: item.date[1],
          team: this.team,
          dimension: item.dimension,
          elementId: item.elementId,
        }
        let data = await this.$http('crmTeamService.getKpiData', params);
        if(!data){
          return;
        }
        data.elementId = item.elementId;
        await this.renderEcharts(data);
      }
    },
    //kpi业绩图加载
    async renderEcharts(data) {
      if(!data.elementId){
        return;
      }
      const chartDom = document.getElementById(data.elementId);
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(chartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(chartDom);
      myChart.setOption(this.getChartOptions(data), true);
    },

    getHistoryChartOptions(){
      return {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: this.historyLengthData
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.historySeriesData
      }
    },


    getChartOptions(data){
      return {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['选择周期','上年同期']
        },
        xAxis: {
          type: 'category',
          data: data.xData
        },
        yAxis: {
          type: 'value'
        },
        series: data.seriesData
      }
    },

    //获取当前日期的这一周开始日期和结束日期
    async getCurrentWeekRange() {
      const today = new Date(); // 当前日期
      this.currentDate = this.formatDate(today);

      // 计算本周的开始时间（周一）
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1)); // 如果今天是周日，则减去6天
      let weekStart = this.formatDate(startOfWeek);

      // 计算本周的结束时间（周日）
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      let weekEnd = this.formatDate(endOfWeek);

      //给基础KPI数据的开始结束日期赋值
      this.kpiList.push({name:'有效电话量',date:[weekStart,weekEnd],dimension:'week',elementId:'phoneChart'});
      this.kpiList.push({name:'有效拜访量',date:[weekStart,weekEnd],dimension:'week',elementId:'visitChart'});
      this.kpiList.push({name:'新增机会',date:[weekStart,weekEnd],dimension:'week',elementId:'chanceChart'});
      this.kpiList.push({name:'新增客户',date:[weekStart,weekEnd],dimension:'week',elementId:'customerChart'});
      this.kpiList.push({name:'新增组织架构',date:[weekStart,weekEnd],dimension:'week',elementId:'organizationChart'});
      this.kpiList.push({name:'新增联系人',date:[weekStart,weekEnd],dimension:'week',elementId:'contactChart'});
    },


    // 格式化日期为 yyyy-mm-dd
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getISOWeekNumber(date, type) {
      // 复制日期对象，避免修改原日期
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      // 保存原始日期的月份
      const originalMonth = d.getMonth() + 1;
      if (type === 'week') {
        // 调整日期到本周的周四
        d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));

        // 获取本年度的第一个周四
        const yearStart = new Date(d.getFullYear(), 0, 1);
        yearStart.setDate(yearStart.getDate() + 3 - ((yearStart.getDay() + 6) % 7));

        // 计算周数
        this.showNumbers = '周数：' + Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      }
      if(type === 'month'){
        // 直接使用原始日期的月份
        this.showNumbers = '月数：' + originalMonth;
      }
      if(type === 'quarter'){
        this.showNumbers = '季度：' + Math.ceil(originalMonth / 3);
      }
      if(type === 'year'){
        this.showNumbers = '年度：' + date.getFullYear();
      }
    },
    // 处理周
    async handleWeek(type) {
      const date = new Date(this.currentDate);
      // 根据类型调整日期
      if (type === 'prev') {
        date.setDate(date.getDate() - 7); // 上周
      } else if (type === 'next') {
        date.setDate(date.getDate() + 7); // 下周
      }
      // 计算本周的周一
      const startOfWeek = new Date(date);
      startOfWeek.setDate(date.getDate() - (date.getDay() === 0 ? 6 : date.getDay() - 1));
      // 计算本周的周日
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      // 更新 businessDate
      this.businessDate = [];
      this.businessDate.push(this.formatDate(startOfWeek)); // 周一
      this.businessDate.push(this.formatDate(endOfWeek));   // 周日
      this.getISOWeekNumber(date,'week');
      // 获取业务数据
      await this.getBusinessData();
    },

    // 处理月
    async handleMonth(type) {
      const date = new Date(this.currentDate);
      if (type === 'prev') {
        date.setMonth(date.getMonth() - 1);
      } else if (type === 'next') {
        date.setMonth(date.getMonth() + 1);
      }
      const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.businessDate = [];
      this.businessDate.push(this.formatDate(startOfMonth));
      this.businessDate.push(this.formatDate(endOfMonth));
      this.getISOWeekNumber(date,'month');
      await this.getBusinessData();
    },

    // 处理季度
    async handleQuarter(type) {
      const date = new Date(this.currentDate);
      if (type === 'prev') {
        date.setMonth(date.getMonth() - 3);
      } else if (type === 'next') {
        date.setMonth(date.getMonth() + 3);
      }
      const currentMonth = date.getMonth();
      let quarterStartMonth;
      if (currentMonth < 3) {
        quarterStartMonth = 0;
      } else if (currentMonth < 6) {
        quarterStartMonth = 3;
      } else if (currentMonth < 9) {
        quarterStartMonth = 6;
      } else {
        quarterStartMonth = 9;
      }
      const startOfQuarter = new Date(date.getFullYear(), quarterStartMonth, 1);
      const endOfQuarter = new Date(date.getFullYear(), quarterStartMonth + 3, 0);
      this.businessDate = [];
      this.businessDate.push(this.formatDate(startOfQuarter));
      this.businessDate.push(this.formatDate(endOfQuarter));
      this.getISOWeekNumber(date,'quarter');
      await this.getBusinessData();
    },

    // 处理年度
    async handleYear(type) {
      const date = new Date(this.currentDate);
      if (type === 'prev') {
        date.setFullYear(date.getFullYear() - 1);
      } else if (type === 'next') {
        date.setFullYear(date.getFullYear() + 1);
      }
      const startOfYear = new Date(date.getFullYear(), 0, 1);
      const endOfYear = new Date(date.getFullYear(), 12, 0);
      this.businessDate = [];
      this.businessDate.push(this.formatDate(startOfYear));
      this.businessDate.push(this.formatDate(endOfYear));
      this.getISOWeekNumber(date,'year');
      await this.getBusinessData();
    },
  }

}
</script>

<style scoped>

.outer_layer_class{
  width: 250px;
  height: 140px;
  border: 1px solid #3d96f3;
  margin-left: 20px;
  margin-top: 10px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.out_font_class{
  margin-top: 10px;
  margin-left: 20px;
  font-size: 20px;
  color: #0478E6FF;
  font-weight: bold;
}

.font_class{
  line-height: 40px;
  margin-left: 20px;
  position: absolute;
  top: 0;
  left: 0;
  color: #777777;
}

.d_shadow{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #D2D2D2FF;
  clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 15% 100%);
}

.d_class {
  text-align: center;
  font-size: 25px;
  color: white;
  line-height: 50px;
  background-color: #3498db;
  clip-path: polygon(0% 0%, 100% 0%, 75% 100%, 25% 100%);
}

.c_shadow{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #D2D2D2FF;
  clip-path: polygon(15% 0%, 85% 0%, 77% 100%, 23% 100%);
}

.c_class {
  text-align: center;
  font-size: 25px;
  color: white;
  line-height: 50px;
  background-color: #39CDE5FF;
  clip-path: polygon(25% 0%, 75% 0%, 65% 100%, 35% 100%);
}

.b_shadow{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #D2D2D2FF;
  clip-path: polygon(23% 0%, 77% 0%, 70% 100%, 30% 100%);
}

.b_class{
  text-align: center;
  font-size: 25px;
  color: white;
  line-height: 50px;
  background-color: #4FE5BBFF;
  clip-path: polygon(35% 0%, 65% 0%, 60% 100%, 40% 100%);
}

.a_shadow{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #D2D2D2FF;
  clip-path: polygon(30% 0%, 70% 0%, 64% 100%, 36% 100%);
}

.a_class{
  text-align: center;
  font-size: 25px;
  color: white;
  line-height: 50px;
  background-color: #1ECC7CFF;
  clip-path: polygon(40% 0%, 60% 0%, 55% 100%, 45% 100%);
}

.w_class{
  width: 50%;
  line-height: 50px;
  text-align: center;
  background-color: #E17C00FF;
  color: white;
  font-size: 25px;

}

.f_class{
  width: 50%;
  line-height: 50px;
  text-align: center;
  background-color: #777777FF;
  color: white;
  font-size: 25px
}

.w_image_class{
  width: 980px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  color: #E17C00FF;
  position: absolute;
  top: 10px;
  left: 10px;
  border: 1px solid #E17C00FF;
  background-color: white;
}

.d_image_class{
  width: 125px;
  height: 50px;
  position: absolute;
  top: 100px;
  left: 105px;
  color: #0069d3;
  background-color: white;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  border: 1px solid #0069d3;
}

.c_image_class{
  width: 125px;
  height: 50px;
  position: absolute;
  top: 100px;
  left: 355px;
  color: #39CDE5FF;
  background-color: white;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  border: 1px solid #39CDE5FF;
}

.b_image_class{
  width: 125px;
  height: 50px;
  position: absolute;
  top: 100px;
  left: 605px;
  color: #4FE5BBFF;
  background-color: white;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  border: 1px solid #4FE5BBFF;
}

.a_image_class{
  width: 125px;
  height: 50px;
  position: absolute;
  top: 100px;
  left: 855px;
  color: #1ECC7CFF;
  background-color: white;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  border: 1px solid #1ECC7CFF;
}

.f_image_class{
  width: 980px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  font-size: 25px;
  text-align: center;
  color: #777777FF;
  position: absolute;
  top: 190px;
  left: 10px;
  border: 1px solid #777777FF;
  background-color: white
}



.arrow-line-right {
  width: 100px;
  height: 2px;
  background-color: #0478e4;
  position: relative;
}

.arrow-line-right::before {
  content: '';
  position: absolute;
  right: -10px;
  top: -5px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #0478e4;
}

.arrow-line-left {
  width: 100px;
  height: 2px;
  background-color:#777777FF;
  position: relative;
}

.arrow-line-left::before {
  content: '';
  position: absolute;
  left: -10px;
  top: -5px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 10px solid #777777FF;
}

.arrow-up {
  width: 2px;
  height: 25px;
  background-color: #0478e4;
  position: relative;
}

.arrow-up::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #0478e4;
  transform: translateX(-50%);
}

.arrow-down {
  width: 2px;
  height: 25px;
  background-color: #777777FF;
  position: relative;
}

.arrow-down::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #777777FF;
  transform: translateX(-50%);
}



</style>